import React from "react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../components/BottomNav";

const HelpSupport = () => {
    const navigate = useNavigate();

    const faqs = [
        {
            q: "How to add money to wallet?",
            a: "Go to Wallet section, click on 'Add Cash', enter amount and complete payment via Razorpay."
        },
        {
            q: "How long does withdrawal take?",
            a: "Withdrawals are normally processed within 2-24 hours into your registered bank account."
        },
        {
            q: "I joined a contest but it's not showing?",
            a: "Please check the 'My Contests' section. If the match hasn't started, it will be in the 'Upcoming' tab."
        },
        {
            q: "What is the minimum withdrawal amount?",
            a: "The minimum amount you can withdraw is ₹100."
        }
    ];

    const contactSupport = (type) => {
        if (type === 'whatsapp') {
            window.open("https://wa.me/919999999999?text=Hello%20WinroX11%20Support", "_blank");
        } else if (type === 'email') {
            window.open("mailto:support@winrox11.com", "_blank");
        }
    };

    return (
        <div className="bg-theme-bg text-theme-text min-h-screen pb-24 font-sans">
            {/* 🔝 HEADER */}
            <div className="p-4 bg-theme-card border-b border-theme-border sticky top-0 z-50 flex items-center shadow-theme-sm">
                <button 
                  onClick={() => navigate(-1)} 
                  className="w-10 h-10 flex items-center justify-center bg-theme-bg rounded-xl border border-theme-border text-theme-text transition-all active:scale-95 shadow-theme-sm"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>
                <h2 className="font-bold text-lg text-theme-text tracking-tight uppercase flex-1 text-center pr-10">Support</h2>
            </div>

            <div className="p-6 space-y-8">
                {/* 📞 QUICK CONTACT */}
                <div className="grid grid-cols-2 gap-4">
                    <button 
                        onClick={() => contactSupport('whatsapp')}
                        className="bg-theme-card border border-theme-border p-6 rounded-[32px] flex flex-col items-center justify-center space-y-3 active:scale-95 transition-all shadow-theme-sm"
                    >
                        <div className="w-12 h-12 bg-green-500/10 rounded-full flex items-center justify-center text-2xl">💬</div>
                        <span className="text-[10px] font-bold text-theme-text uppercase tracking-widest">WhatsApp</span>
                    </button>
                    <button 
                        onClick={() => contactSupport('email')}
                        className="bg-theme-card border border-theme-border p-6 rounded-[32px] flex flex-col items-center justify-center space-y-3 active:scale-95 transition-all shadow-theme-sm"
                    >
                        <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center text-2xl">📧</div>
                        <span className="text-[10px] font-bold text-theme-text uppercase tracking-widest">Email Support</span>
                    </button>
                </div>

                {/* 🙋 FAQ SECTION */}
                <div className="space-y-4">
                    <h3 className="text-[10px] font-bold text-theme-text-sec uppercase tracking-[0.2em] px-1 opacity-60">Common Questions</h3>
                    <div className="space-y-3">
                        {faqs.map((faq, index) => (
                            <div key={index} className="bg-theme-card border border-theme-border p-5 rounded-2xl shadow-theme-sm">
                                <p className="font-bold text-xs text-theme-text mb-2">Q: {faq.q}</p>
                                <p className="text-[11px] text-theme-text-sec leading-relaxed font-medium opacity-70">{faq.a}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 🛡️ LEGAL LINKS */}
                <div className="bg-theme-card p-2 rounded-[28px] border border-theme-border shadow-theme-sm divide-y divide-theme-border">
                    <button onClick={() => navigate("/terms")} className="w-full p-4 text-left text-[11px] font-bold text-theme-text uppercase tracking-tight flex justify-between items-center group">
                        Terms & Conditions <span className="opacity-30 group-active:translate-x-1 transition-transform">→</span>
                    </button>
                    <button onClick={() => navigate("/privacy")} className="w-full p-4 text-left text-[11px] font-bold text-theme-text uppercase tracking-tight flex justify-between items-center group">
                        Privacy Policy <span className="opacity-30 group-active:translate-x-1 transition-transform">→</span>
                    </button>
                    <button onClick={() => navigate("/fairplay")} className="w-full p-4 text-left text-[11px] font-bold text-theme-text uppercase tracking-tight flex justify-between items-center group">
                        Fair Play Policy <span className="opacity-30 group-active:translate-x-1 transition-transform">→</span>
                    </button>
                </div>

                <div className="text-center pt-8">
                    <p className="text-[8px] text-theme-text-sec uppercase font-bold tracking-[0.4em] opacity-30">WinroX11 Fantasy v1.0.0</p>
                    <p className="text-[9px] text-theme-text-sec font-bold mt-2 opacity-20 uppercase tracking-widest">Built for Champions</p>
                </div>
            </div>

            <BottomNav activeTab="profile" />
        </div>
    );
};

export default HelpSupport;
